import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';


// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const user_id = localStorage.getItem('user_id');
    const scty_id = localStorage.getItem('scty_id');

    if (user_id) {
      if (config.method === 'post' || config.method === 'put') {
        if (config.data instanceof FormData) {
          // Don't overwrite FormData — append user_id safely
          config.data.append('user_id', user_id);
          config.data.append('scty_id', scty_id);
        } else {
          // Regular JSON request — spread as usual
          config.data = { ...config.data, user_id, scty_id };
        }
      }

      if (config.method === 'get') {
        config.params = { ...config.params, user_id, scty_id };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>
<App />
</React.StrictMode>
);